export default __webpack_public_path__ + "static/envelope-21551d5ee6ae4c78ed2913c685fb653e.webp";